import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { QuotationChangeStatusRequest, QuotationStatusMaster, QuotationSummaryUploaded } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { UploadedDocPopupComponent } from '../uploaded-doc-popup-quotation/uploaded-doc-popup.component';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { QuotationSummaryService } from 'src/app/_Services/quotationNew/quotationsummary.service';

@Component({
  selector: 'app-accept-design-popup',
  templateUrl: './accept-design-popup.component.html',
  styleUrls: ['./accept-design-popup.component.scss']
})
export class AcceptDesignPopupComponent implements OnInit, OnDestroy {

  @Input() data!: QuotationSummaryUploaded;
  public model: QuotationChangeStatusRequest;
  public isLoading: boolean = false;
  componentDestroyed$: Subject<boolean> = new Subject();
  @Output() refreshdata = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal,
    public quService: QuotationSummaryService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.model = new QuotationChangeStatusRequest();
    this.model.quotationId = this.data.quotationId;
    this.model.statusId = QuotationStatusMaster.Approved;
  }

  cancelClicked() {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(UploadedDocPopupComponent, { centered: true, windowClass: 'document-popup-wrapper certifcate-view-popup' });
    modalRef.componentInstance.data = this.data;   // pass data to popup

    modalRef.componentInstance.setPdf(this.data.quotationFileUrl);
  }

  saveApproveQuotation() {
    this.isLoading = true;
    this.quService.updateQuotationStatus(this.model)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (response) {
            if (response && response == 1) {
              // Show success toaster
              this.toastr.success(
                this.translate.instant('Quotation approved successfully')
              );
              this.modalService.dismissAll();
              // Close modal and refresh page to show updated data
              // setTimeout(() => {
              //   // Refresh the page to show updated data
              //   window.location.reload();
              // }, 1500);
              this.refreshdata.emit();
            } else {
              this.toastr.error(
                this.translate.instant('Failed to approve quotation')
              );
            }
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error(
            this.translate.instant('An error occurred while approving the quotation')
          );
          console.error('Approval error:', error);
        }
      );
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
